import { useToggle } from '../hooks/useToggle'
import { PageModal } from './AccountModal'
import { FormClaimTransaction } from './FormClaimTransaction'
import { accountTranslations } from '../helpers/translations'
const transactionData = accountGlobal?.transaction?.card ?? {
  title: 'Forgot to scan your card for a recent purchase?',
  cardBody: 'No worries! Enter the details from your receipt to claim your rewards.',
  featureImage:
    'https://shoesandsox.com.au/cdn/shop/files/MINI_SNEAKER_FREAKER_1187X1143_4f4eee3d-7d38-45f7-a297-84eb5aa3dcf5.png?v=1729490396&width=1187'
}

export const AccountBannerTransitions = () => {
  const { isActive, handleToggle } = useToggle(false)

  return (
    <PageModal
      props={{
        isActive,
        handleToggle,
        modalTitle: accountTranslations.my_rewards.history.banner.title,
        modal: <FormClaimTransaction closeModal={handleToggle} />
      }}
    >
      <AccountBanner
        {...{
          title: transactionData.title,
          body: transactionData.cardBody,
          cta: {
            hook: 'transaction',
            callback: handleToggle,
            title: accountTranslations.my_rewards.history.banner.cta
          },
          img: {
            src: transactionData.featureImage
          }
        }}
      />
    </PageModal>
  )
}

export const AccountBannerFormAppointments = () => (
  <AccountBanner
    {...{
      fullWidth: true,
      title: accountTranslations.kids_profiles.measurements.banner.title,
      body: accountTranslations.kids_profiles.measurements.banner.body,
      cta: {
        hook: 'appointment',
        callback: () => {
          window.open('/pages/book-a-fitting', '_blank').focus()
        },
        title: accountTranslations.kids_profiles.measurements.banner.cta
      }
    }}
  />
)

/**
 *
 * @param {{title: string, fullWidth?: boolean body: string, cta: {title: string, hook: string, callback: (section: string) => void}, img: {src: string}}} props
 * @returns
 */
const AccountBanner = (props) => {
  return (
    <div className={'w-full bg-secondary-yellow mt-4'}>
      <div className={'flex flex-col gap-10 p-10 md:flex-row'}>
        {props?.img?.src && (
          <div className={'w-full md:w-1/2'}>
            <div className={'aspect-4/3 w-full'}>
              <img
                src={
                  props?.img?.src ??
                  'https://shoesandsox.com.au/cdn/shop/files/MINI_SNEAKER_FREAKER_1187X1143_4f4eee3d-7d38-45f7-a297-84eb5aa3dcf5.png?v=1729490396&width=1187'
                }
                className={'h-full w-full object-cover'}
              />
            </div>
          </div>
        )}
        <div
          className={`m-auto flex h-full  flex-col justify-center gap-4 ${
            props.fullWidth ? 'w-full' : 'w-full md:w-1/2'
          }`}
        >
          {props.title && <h2 class={'h2 font-bold'}>{props.title}</h2>}
          {props.body && <p className={'paragraph-md'}>{props.body}</p>}
          {props.cta && (
            <div
              onClick={() => {
                props.cta.callback(props.cta.hook)
              }}
              className={'btn btn-md btn-solid-black w-fit'}
            >
              {props.cta.title}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
